export const domain = 'ProjectsSettingsModel'

export const onUpdateUserProjectSettings = `${domain}/onUpdateUserProjectSettings`
export const onFetchUserProjectSettings = `${domain}/onFetchUserProjectSettings`
export const onFetchUserProjectSettingsSuccess = `${domain}/onFetchUserProjectSettingsSuccess`
